/**
 * Single source of truth for page sizes on organisation listings.
 */
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100]

export const DEFAULT_ROWS_PER_PAGE = 10

export const MAX_PAGE_SIZE = 100

/** Label used by MUI TablePagination for "show every row". */
export const ALL_ROWS_LABEL = 'All'

/** Large page size sent to the API when the operator picks "All". */
export const ALL_ROWS_REQUEST_SIZE = 99999

export const DEFAULT_GRID_ROWS_PER_PAGE = 12

/** Multiples of 12 so every card row fills at 1–4 columns. */
export const GRID_ROWS_PER_PAGE_OPTIONS = [12, 24, 48, ALL_ROWS_LABEL]

export const isAllRowsSelection = size => size === ALL_ROWS_LABEL || size === 'All'

export const normalizePageSize = size => {
  if (isAllRowsSelection(size)) {
    return ALL_ROWS_REQUEST_SIZE
  }

  const parsed = typeof size === 'number' ? size : parseInt(size, 10)

  if (!parsed || Number.isNaN(parsed)) {
    return DEFAULT_ROWS_PER_PAGE
  }

  return Math.min(parsed, MAX_PAGE_SIZE)
}

/**
 * Value stored in UI state (Redux / component state) when the rows-per-page
 * control changes. Keeps the literal "All" label so TablePagination stays in sync.
 */
export const parseRowsPerPageSelection = value => {
  if (isAllRowsSelection(value)) {
    return ALL_ROWS_LABEL
  }

  const parsed = typeof value === 'number' ? value : parseInt(value, 10)

  if (!parsed || Number.isNaN(parsed)) {
    return DEFAULT_ROWS_PER_PAGE
  }

  return Math.min(parsed, MAX_PAGE_SIZE)
}

/** Rows-per-page for client-side slices (Home / QcsHome listings). */
export const effectivePageSize = (rowsPerPage, totalRows) => {
  return isAllRowsSelection(rowsPerPage) ? totalRows : rowsPerPage
}
